"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetReferralCodesResponseToJSON = exports.GetReferralCodesResponseFromJSONTyped = exports.GetReferralCodesResponseFromJSON = void 0;
var _1 = require("./");
function GetReferralCodesResponseFromJSON(json) {
    return GetReferralCodesResponseFromJSONTyped(json, false);
}
exports.GetReferralCodesResponseFromJSON = GetReferralCodesResponseFromJSON;
function GetReferralCodesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referralCodes': (json['referralCodes'].map(_1.ReferralCodeFromJSON)),
    };
}
exports.GetReferralCodesResponseFromJSONTyped = GetReferralCodesResponseFromJSONTyped;
function GetReferralCodesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'referralCodes': (value.referralCodes.map(_1.ReferralCodeToJSON)),
    };
}
exports.GetReferralCodesResponseToJSON = GetReferralCodesResponseToJSON;
